import fetch from "../config/http"
import { portalBasicApi } from "../config/configApi"

export const GetSystemConfig = () => fetch( portalBasicApi + '/SystemConfig/GetConfig');

export const GetServerDateTime = () => fetch(portalBasicApi + '/SystemConfig/GetDateTime')

export const GetLanguageType = () => fetch( portalBasicApi + '/Language/GetLanguageType');

//设置用户语言类型
export const SetLanguage = (lang) => fetch( portalBasicApi + '/Users/SetUserLanguage?language=' + lang, {}, 'POST');

export const GetLanguageByApp = () => fetch(portalBasicApi + '/Language/GetLanguageByApp');